import React from "react";

const ArcadeCart: React.FC = () => {
  return (
    <>
      <div className="tw-text-white">arcade cart component is here</div>
    </>
  );
};

export default ArcadeCart;
